import { useState, useEffect } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
 diagnosisRegisterSchema,
 diagnosisRegisterSchemaUpdate,
} from '../core/validations/diagnosis_register';
import { diagnosisEditSchema } from '../core/validations/diagnosis_edit';

export const useDiagnosisForm = ({ isEditing = false, initialData = null }) => {
 const [showPillarsTabs, setShowPillarsTabs] = useState(isEditing);
 const [pillarCount, setPillarCount] = useState(initialData?.form?.length || 0);
 const [confirmedPillars, setConfirmedPillars] = useState(initialData?.form?.length || 0);

 const getSchema = () => {
  if (isEditing) {
   return diagnosisEditSchema;
  }
  return showPillarsTabs ? diagnosisRegisterSchemaUpdate : diagnosisRegisterSchema;
 };

 const formMethods = useForm({
  resolver: yupResolver(getSchema()),
  defaultValues: initialData || {},
 });

 const { fields, append, remove, update } = useFieldArray({
  control: formMethods.control,
  name: 'form',
 });

 useEffect(() => {
  if (!isEditing || !initialData) {
   handleNumPilaresChange(pillarCount);
  }
 }, [isEditing, initialData, pillarCount]);

 const handleNumPilaresChange = (count) => {
  setPillarCount(count);
  const currentCount = fields.length;

  const isAddingNewPillars = count > currentCount;
  const isRemovingPillars = count < currentCount;

  if (isAddingNewPillars) {
   for (let i = currentCount; i < count; i++) {
    append(
     {
      pillarName: '',
      numberOfThemes: '',
      numberOfLevels: '',
      new: true,
      themes: [],
      levels: [],
      pillarText: '',
      helpTitle: '',
      helpText: '',
     },
     { shouldFocus: false }
    );
   }
  } else if (isRemovingPillars) {
   for (let i = currentCount - 1; i >= count; i--) {
    remove(i);
   }
  }
 };

 const confirmNewPillars = () => {
  fields.forEach((field, index) => {
    if (field.invisible) {
      update(index, { ...field, invisible: false });
    }
  });
  setConfirmedPillars(fields.length);
  setShowPillarsTabs(true);
 };

 return {
  showPillarsTabs,
  setShowPillarsTabs,
  pillarCount,
  setPillarCount,
  formMethods,
  fields,
  handleNumPilaresChange,
  append,
  remove,
  update,
  confirmNewPillars,
 };
};
